/**
 * Власне мобільне меню (замість вбудованого WP overlayMenu — розділ 18,
 * грабля №35/№36 у CLAUDE.md). .is-open toggle вішаємо на .site-header
 * (а не на .nav__links) — WP дублює className блоку wp:navigation і на
 * <nav>, і на вкладений <ul>, тому toggle на предку (.site-header) через
 * власний wrapper .nav__collapse — надійніше, ніж на самому wp:navigation.
 */
export default function mobileNav() {
	const header = document.querySelector('.site-header');
	const burger = document.querySelector('.nav__burger');
	const collapse = document.querySelector('.nav__collapse');
	if (!header || !burger || !collapse) return;

	const setOpen = (open) => {
		header.classList.toggle('is-open', open);
		burger.setAttribute('aria-expanded', String(open));
		// Блокуємо скрол фону, поки overlay відкритий. Клас на <html> (а не
		// лише inline overflow на <body>) — надійніше на мобільних браузерах
		// (деякі, напр. iOS Safari, не завжди зупиняють touch-скрол лише від
		// body.style.overflow). Стилі — style.scss (html.is-nav-locked).
		document.documentElement.classList.toggle('is-nav-locked', open);
	};

	burger.addEventListener('click', () => {
		setOpen(!header.classList.contains('is-open'));
	});

	collapse.querySelectorAll('a').forEach((a) => {
		a.addEventListener('click', () => setOpen(false));
	});

	document.addEventListener('keydown', (e) => {
		if (e.key === 'Escape') setOpen(false);
	});

	// На переході до десктопного брейкпоінта — закрити, щоб не лишалось
	// "відкритим" у фоні (той самий поріг, що й .nav__burger { @include breakpoint }).
	const mq = window.matchMedia('(min-width: 1100px)');
	const onChange = (e) => {
		if (e.matches) setOpen(false);
	};
	if (mq.addEventListener) {
		mq.addEventListener('change', onChange);
	} else {
		mq.addListener(onChange);
	}
}
